export default __webpack_public_path__ + "assets/removal_awareness.7dedca09.png";